import { CircularProgress } from "@mui/material";
import { FC, ReactNode } from "react";

import {
  LIVE_MAP_POLL_PROGRESS_ICON_RING_SIZE,
  LIVE_MAP_POLL_PROGRESS_ICON_RING_THICKNESS,
  LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_SIZE,
  LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_THICKNESS,
} from "./live-map.controls.constants";
import { LiveMapPollProgressRingWrapStyled } from "./live-map.poll-progress-ring.styled";
import { useLiveMapPollCycleProgress } from "./use-live-map-poll-progress";

export interface ILiveMapPollProgressRingProps {
  lastSyncIso: TDateISO | undefined;
  intervalMs: number;
  isPollingActive: boolean;
  children?: ReactNode;
}

export const LiveMapPollProgressRing: FC<ILiveMapPollProgressRingProps> = ({
  lastSyncIso,
  intervalMs,
  isPollingActive,
  children,
}) => {
  const elapsedPercent = useLiveMapPollCycleProgress({
    lastSyncIso,
    intervalMs,
    isPollingActive,
  });

  const isRingVisible = isPollingActive && Boolean(lastSyncIso);
  const withCenterIcon = Boolean(children);
  const ringSize = withCenterIcon
    ? LIVE_MAP_POLL_PROGRESS_ICON_RING_SIZE
    : LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_SIZE;
  const ringThickness = withCenterIcon
    ? LIVE_MAP_POLL_PROGRESS_ICON_RING_THICKNESS
    : LIVE_MAP_POLL_PROGRESS_STANDALONE_RING_THICKNESS;

  if (!withCenterIcon && !isRingVisible) {
    return null;
  }

  return (
    <LiveMapPollProgressRingWrapStyled $withCenterIcon={withCenterIcon}>
      {isRingVisible && (
        <>
          <CircularProgress
            className="live-map-poll-progress-track"
            variant="determinate"
            value={100}
            size={ringSize}
            thickness={ringThickness}
          />
          <CircularProgress
            className="live-map-poll-progress-indicator"
            variant="determinate"
            value={elapsedPercent}
            size={ringSize}
            thickness={ringThickness}
          />
        </>
      )}
      {children ? (
        <span className="live-map-poll-progress-center">{children}</span>
      ) : null}
    </LiveMapPollProgressRingWrapStyled>
  );
};
